import type { Element } from '../../domain/game/elements';

export type GameSignal =
  | { type: 'room-transition'; roomId: string }
  | {
      type: 'play-enemy-hit-fx';
      damage: number;
      source: 'skill' | 'status';
      element?: Element;
    }
  | { type: 'play-enemy-miss-fx' }
  | { type: 'enemy-defeated'; enemyId: string }
  | { type: 'player-defeated' };

type Listener = (signal: GameSignal) => void;

const listeners = new Set<Listener>();

export const gameSignals = {
  emit(signal: GameSignal) {
    listeners.forEach((listener) => listener(signal));
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
